import axios from 'axios'
import store from '@/store'
import qs from 'qs'

axios.defaults.timeout = 300 *1000;

// 20201125 ie 에서 캐시에서 읽어 오는 케이스 막기 위해 추가함
axios.defaults.headers['Pragma'] = 'no-cache';

// S. [23.09.26] 대괄호 url encoding 처리를 위해 공통 paramsSerializer 설정
axios.defaults.paramsSerializer = params => {
	return qs.stringify(params, {
		skipNulls : true,
	});
}
// E. [23.09.26] 대괄호 url encoding 처리를 위해 공통 paramsSerializer 설정


axios.interceptors.request.use(config => {
	config.headers['x-lang-cd'] = store.state.langTyCode;
	config.headers['x-device-id'] = store.state.deviceId;
	config.headers['x-mber-no'] = store.state.mberInfo.mberNo;
	config.headers['x-scm-token'] = store.state.xScmToken;
	config.headers['x-ref-token'] = store.state.xRefToken;
	store.commit("loadingOn");

	return config;
}, error => {
	store.commit("loadingOff");
	return Promise.reject(error);
});

const filteredErrCode = [
	"FC2001"
];
axios.interceptors.response.use(response => {
	store.commit("loadingOff");

	if (response.data.code !== undefined && response.data.code !== "S00000") {
		//foUtils.$alert(response.data.message)
	}
	return response
}, error => {
	store.commit("loadingOff");

	if(!!error.response && !!error.response.data){
		if (!!error.response && error.response.status === 503) {
			window.location.replace(process.env.VUE_APP_EMARTICON_SITE_DOMAIN + '/error');
		}
		const status = error.response.status
		const data = error.response.data;
		const config = error.config;

		//TODO : axios error 케이스 수정 필요!
		if(status === 403) {
			// 로그아웃 처리 필요
			let mberInfo = {
				xScmToken : null,
				xRefToken : null,
				mberNo : null
			}
			store.commit("setMberInfo", mberInfo);
			if(window.location.pathname != '/home' && window.location.pathname != '/award/awardCode') {
				window.location.href = '/home';
			}
			return error.response.data;
		}

		if (filteredErrCode.indexOf(data.code) == -1) {
			// console.dir("not filtered error")
			// console.dir(data);
			const alertMsg = data.message ? data.message.replace(/(\r\n|\n|\\n)/g, "</br>") : status;
			//alert(alertMsg);
			return error.response.data;
		} else if (status === 403 || 'SYS9996'.indexOf(data.code) > -1) {
			// 로그아웃 처리 필요
			// store.commit("ssgpUserStore/resetData");
			// location.replace('/error');
			return Promise.reject(error);
		} else {
			return Promise.reject(error);
		}
	} else {
		console.log('check 403', error)
		return Promise.reject(error);
	}
})
export default axios;